var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gallery-form-group',{attrs:{"name":"image_id","label":"Image","error":(_vm.errors.image_id || [])[0]},model:{value:(_vm.data.image_id),callback:function ($$v) {_vm.$set(_vm.data, "image_id", $$v)},expression:"data.image_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }